// extracted by mini-css-extract-plugin
module.exports = {"root":"Marquee_root__RYtHi","wrapper":"Marquee_wrapper__bgcrm","show":"Marquee_show___eVXU","text":"Marquee_text__P_rej","img":"Marquee_img__wRyaC"};